import React, { useRef, useEffect } from 'react';
import { Input, Form } from '@ss/mtd-react';
import { Select } from '@block/plug';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import { getEnumByCategory } from '@service/resumeDetail';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

// 仅社招
function SocialAccount(props) {
  const formRefs = useRef<any[]>([]);

  const { data } = props;
  const { socialResumeDetail, socialResumeFormRefStore } = useRootStore();
  const store = socialResumeDetail;
  const storeRef = socialResumeFormRefStore;

  useEffect(() => {
    storeRef.changeRef('resumeSocialAccountListRef', formRefs.current);
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    switch (formItemKey) {
      case 'name': {
        store.setResumeSocialAccountList(index, 'name', formItemValue?.name ? formItemValue.name : '');
        store.setResumeSocialAccountList(index, 'socialAccountCode', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      default:
        store.setResumeSocialAccountList(index, formItemKey, formItemValue);
    }
  };

  const handleFetchData = async (category: string) => {
    const res = await getEnumByCategory({ category });
    return res;
  };

  return (
    <div className="social_account_edit model_edit">
      <div className="model_title">社交账号</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="name" span="11" labelWidth={0} required message="请填写账号">
              <div className="label">
                账号名称<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请输入账号名称"
                labelField="name"
                keyField="id"
                onFetchData={() => handleFetchData('socialNetWorkSiteName')}
              />
            </FormItem>
            <FormItem formItemKey="homePage" span="11" labelWidth={0} required message="请填写账号URL">
              <div className="label">
                URL<span className="icon">*</span>
              </div>
              <Input toFormItem size="large" placeholder="请输入" />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeSocialAccountList', index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div
        className="list_add"
        onClick={() => {
          store.addResumeList('resumeSocialAccountList');
        }}
      >
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加社交账号
      </div>
    </div>
  );
}

export default ModuleView(observer(SocialAccount), 'SocialAccount');
